import { FormGroup } from '@angular/forms';
import type {
  SolarPanelsWizardForm,
  SolarPanelsWizardRendering,
} from '@feh/solar-panels-models';
import {
  RfaComponents,
  RfaFormControl,
  RfaTransformers,
  RfaValidators,
} from '@innogy/feh/rfa';
import { getLeadAddressFormControls } from '@innogy/feh/shared';
import type { ScText } from '@legacy/common-ui-models';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-angular';

export function createWizardForm(
  rendering: SolarPanelsWizardRendering
): SolarPanelsWizardForm {
  return new FormGroup({
    address: new FormGroup(
      getLeadAddressFormControls(
        {
          ...rendering,
          fields: {
            PostalCodeLabel: rendering.fields.PostalCodeLabel as ScText,
            PostalCodeRequiredError: rendering.fields
              .PostalCodeRequiredError as ScText,
            PostalCodeInvalidError: rendering.fields
              .PostalCodeNotValidError as ScText,
            HouseNumberLabel: rendering.fields.HouseNumberLabel as ScText,
            HouseNumberRequiredError: rendering.fields
              .HouseNumberRequiredError as ScText,
            HouseNumberAdditionLabel: rendering.fields
              .HouseNumberAdditionLabel as ScText,
            StreetLabel: { value: '' },
            StreetRequiredError: { value: '' },
            CityLabel: { value: '' },
            CityRequiredError: { value: '' },
          },
        },
        rendering.fields.componentName.value,
        false
      )
    ),
    consumption: new RfaFormControl<string, typeof RfaComponents.TextInput>(
      '',
      {
        label: getFieldValue(rendering, 'ElectricityUsageLabel', ''),
        helpText: rendering.fields.ElectricityUsageTooltip.value,
        prefix: { icon: 'plug' },
        suffix: { text: 'kWh' },
        transformers: [RfaTransformers.number()],
        validators: [RfaValidators.required],
        analytics: {
          focusChangeTracker: {
            componentName: rendering.fields.componentName.value,
            fieldName: 'stroomverbruik jaar',
          },
        },
        errorMsgs: {
          required: 'Vul je stroomverbruik in',
        },
        dataAutomationId: 'solarPanelsWizardForm-consumption',
      },
      RfaComponents.TextInput
    ),
    houseType: new RfaFormControl<string, typeof RfaComponents.RadioGroup>(
      '',
      {
        label: getFieldValue(rendering, 'HouseIsBoughtLabel', ''),
        validators: [RfaValidators.required],
        errorMsgs: {
          required: 'Kies een optie',
        },
        entries: [
          {
            text: getFieldValue(rendering, 'SuitableHouseTypeOptionLabel', ''),
            value: 'bought_with_own_roof',
          },
          {
            text: getFieldValue(
              rendering,
              'UnsuitableHouseTypeOptionLabel',
              ''
            ),
            value: 'other',
          },
        ],
        dataAutomationId: 'solarPanelsWizardForm-houseType',
        analytics: {
          valueChangeTracker: {
            componentName: rendering.fields.componentName.value,
            fieldName: '',
          },
        },
      },
      RfaComponents.RadioGroup
    ),
  });
}
